module.exports = __webpack_public_path__ + "static/media/youtube.dd632740.svg";